const state = {
  rules: [],
  response: {
    showAlertBox: false,
    allowProceed: false,
    allowSendConditioning: true,
    // firstOpen: false
  }
}

// this.$store.apiValidation.getters.validate()
const getters = {
  rules: (state) => state.rules,
  response: (state) => state.response,
  // hasErrors: (state) => state.hasErrors
  hasErrors: (state) => {
    const ruleGroups = state.rules

    let totalErrors = 0
    ruleGroups.forEach((group, i) => { if (Array.isArray(group)) totalErrors += group.length })
    const hasErrors = totalErrors > 0

    // context.commit('hasErrors', hasErrors)
    return hasErrors
  }
}

const mutations = {
  checkRules(state, ruleGroups) {
    state.rules = ruleGroups
  },
  setResponse(state, response) {
    state.response = Object.assign(state.response, response)
  },
  hasErrors(state, hasErrors) {
    state.hasErrors = hasErrors
  }
}

const actions = {
  checkRules(context, ruleGroups) {
    context.commit('checkRules', ruleGroups)

  },
  setResponse(context, response) {
    context.commit('setResponse', response)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
